module.exports = __webpack_public_path__ + "img/logotipo_flit2go.a5cb5ecc.png";